import { render, staticRenderFns } from "./ModalWithdrawOrderExpiredError.vue?vue&type=template&id=ba239caa&"
import script from "./ModalWithdrawOrderExpiredError.vue?vue&type=script&lang=js&"
export * from "./ModalWithdrawOrderExpiredError.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithdrawOrderExpiredError.vue?vue&type=style&index=0&id=ba239caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports